import React, { memo } from 'react';
import { Avatar, Box } from '@mui/material';

// ペルソナ別のSVGアイコン
const PERSONA_SVGS = {
  // 文芸批評家・山田 — メガネ + 本のイメージ
  critic: (
    <svg viewBox="0 0 40 40" width="100%" height="100%">
      <circle cx="20" cy="16" r="9" fill="rgba(255,255,255,0.9)" />
      <circle cx="20" cy="16" r="8" fill="rgba(255,255,255,0.2)" />
      {/* 髪 */}
      <path d="M11 14 Q11 7 20 6 Q29 7 29 14" fill="rgba(255,255,255,0.7)" />
      {/* メガネ */}
      <rect x="13" y="14" width="5" height="4" rx="1.5" fill="none" stroke="white" strokeWidth="1.2" />
      <rect x="22" y="14" width="5" height="4" rx="1.5" fill="none" stroke="white" strokeWidth="1.2" />
      <line x1="18" y1="15.5" x2="22" y2="15.5" stroke="white" strokeWidth="0.8" />
      {/* 目 */}
      <circle cx="15.5" cy="16" r="1" fill="white" />
      <circle cx="24.5" cy="16" r="1" fill="white" />
      {/* 口 */}
      <path d="M17 21 Q20 23 23 21" fill="none" stroke="rgba(255,255,255,0.7)" strokeWidth="0.8" />
      {/* 本 */}
      <rect x="12" y="28" width="16" height="10" rx="1" fill="rgba(255,255,255,0.25)" />
      <line x1="20" y1="28" x2="20" y2="38" stroke="rgba(255,255,255,0.5)" strokeWidth="0.8" />
      <line x1="14" y1="31" x2="18" y2="31" stroke="rgba(255,255,255,0.4)" strokeWidth="0.5" />
      <line x1="14" y1="33" x2="18" y2="33" stroke="rgba(255,255,255,0.4)" strokeWidth="0.5" />
      <line x1="22" y1="31" x2="26" y2="31" stroke="rgba(255,255,255,0.4)" strokeWidth="0.5" />
      <line x1="22" y1="33" x2="26" y2="33" stroke="rgba(255,255,255,0.4)" strokeWidth="0.5" />
    </svg>
  ),

  // 熱心な読者・佐藤 — 目がキラキラ + ハートのイメージ
  reader: (
    <svg viewBox="0 0 40 40" width="100%" height="100%">
      <circle cx="20" cy="16" r="9" fill="rgba(255,255,255,0.9)" />
      <circle cx="20" cy="16" r="8" fill="rgba(255,255,255,0.2)" />
      {/* 髪 */}
      <path d="M11 15 Q10 6 20 5 Q30 6 29 15" fill="rgba(255,255,255,0.7)" />
      <path d="M11 15 Q10 12 12 10" fill="rgba(255,255,255,0.5)" />
      <path d="M29 15 Q30 12 28 10" fill="rgba(255,255,255,0.5)" />
      {/* キラキラ目 */}
      <circle cx="15.5" cy="15" r="2" fill="white" />
      <circle cx="14.5" cy="14.2" r="0.6" fill="rgba(255,255,255,0.3)" />
      <circle cx="24.5" cy="15" r="2" fill="white" />
      <circle cx="23.5" cy="14.2" r="0.6" fill="rgba(255,255,255,0.3)" />
      {/* にっこり口 */}
      <path d="M16 20 Q20 24 24 20" fill="none" stroke="white" strokeWidth="1" strokeLinecap="round" />
      {/* ハート */}
      <path d="M18 30 Q18 27 20 29 Q22 27 22 30 L20 34 Z" fill="rgba(255,255,255,0.6)" />
      {/* 星 */}
      <polygon points="30,28 31,31 34,31 31.5,33 32.5,36 30,34 27.5,36 28.5,33 26,31 29,31" fill="rgba(255,255,255,0.35)" />
      <polygon points="10,30 10.7,32 13,32 11.2,33.3 11.8,35.5 10,34 8.2,35.5 8.8,33.3 7,32 9.3,32" fill="rgba(255,255,255,0.25)" />
    </svg>
  ),

  // ベテラン編集者・鈴木 — ペン + 鋭い目のイメージ
  editor: (
    <svg viewBox="0 0 40 40" width="100%" height="100%">
      <circle cx="20" cy="16" r="9" fill="rgba(255,255,255,0.9)" />
      <circle cx="20" cy="16" r="8" fill="rgba(255,255,255,0.2)" />
      {/* 髪（短め・きっちり） */}
      <path d="M12 14 Q12 6 20 5 Q28 6 28 14" fill="rgba(255,255,255,0.7)" />
      <line x1="14" y1="8" x2="26" y2="8" stroke="rgba(255,255,255,0.3)" strokeWidth="0.5" />
      {/* 鋭い目 */}
      <path d="M13 15 L16 14 L18 15 L16 16 Z" fill="white" />
      <circle cx="15.5" cy="15" r="0.8" fill="rgba(255,255,255,0.5)" />
      <path d="M22 15 L24 14 L27 15 L24 16 Z" fill="white" />
      <circle cx="24.5" cy="15" r="0.8" fill="rgba(255,255,255,0.5)" />
      {/* 引き締まった口 */}
      <line x1="17" y1="21" x2="23" y2="21" stroke="white" strokeWidth="0.8" strokeLinecap="round" />
      {/* ペン */}
      <line x1="28" y1="38" x2="34" y2="26" stroke="rgba(255,255,255,0.6)" strokeWidth="1.5" strokeLinecap="round" />
      <polygon points="34,26 35,25 34.2,24.2" fill="rgba(255,255,255,0.7)" />
      {/* チェックマーク */}
      <path d="M8 32 L11 35 L16 28" fill="none" stroke="rgba(255,255,255,0.5)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
};

// ペルソナカラー（唯一のソース — 他ファイルはここからインポートすること）
const PERSONA_COLORS = {
  // 既存3人
  critic: '#9c27b0',
  reader: '#2196f3',
  editor: '#4caf50',
  // 分析枠
  himuro_ran: '#7b1fa2',
  shiranami_noa: '#546e7a',
  todo_chitose: '#c62828',
  // 感性枠
  amane_rin: '#ef6c00',
  hinata_yui: '#e91e8f',
  sakuraba_miyabi: '#6a1b9a',
  // 実務枠
  kurosaki_rin: '#37474f',
  kujo_tsumugi: '#558b2f',
  murakumo_akane: '#d32f2f',
};

// ペルソナ画像パス
const PERSONA_IMAGES = {
  critic: '/icons/reviewer-critic-circle.avif',
  reader: '/icons/reviewer-reader-circle.avif',
  editor: '/icons/reviewer-editor-circle.avif',
  himuro_ran: '/icons/reviewer-himuro-circle.avif',
  shiranami_noa: '/icons/reviewer-shiranami-circle.avif',
  todo_chitose: '/icons/reviewer-todo-circle.avif',
  amane_rin: '/icons/reviewer-amane-circle.avif',
  hinata_yui: '/icons/reviewer-hinata-circle.avif',
  sakuraba_miyabi: '/icons/reviewer-sakuraba-circle.avif',
  kurosaki_rin: '/icons/reviewer-kurosaki-circle.avif',
  kujo_tsumugi: '/icons/reviewer-kujo-circle.avif',
  murakumo_akane: '/icons/reviewer-murakumo-circle.avif',
};

const PersonaAvatar = memo(({ personaType, size = 32, sx = {}, customIcon = '' }) => {
  const color = PERSONA_COLORS[personaType] || '#9c27b0';
  const imageSrc = PERSONA_IMAGES[personaType];

  // カスタムペルソナ判定
  const isCustom = personaType?.startsWith('custom_');

  // カスタムペルソナのアイコンが絵文字の場合（短い文字列でURL/パスではない）
  const isEmojiIcon = customIcon && customIcon.length <= 4 && !customIcon.startsWith('/') && !customIcon.startsWith('http');
  const src = isCustom ? (isEmojiIcon ? '' : (customIcon || '')) : imageSrc;

  return (
    <Avatar
      src={src || undefined}
      sx={{
        width: size,
        height: size,
        bgcolor: isCustom ? '#4f46e5' : color,
        border: `2px solid ${isCustom ? '#4f46e5' : color}`,
        fontSize: isEmojiIcon ? size * 0.5 : size * 0.4,
        ...sx,
      }}
    >
      {/* カスタムペルソナの絵文字 or フォールバック */}
      {isEmojiIcon ? customIcon : (
        <Box sx={{ fontSize: size * 0.4, fontWeight: 600, color: 'white' }}>AI</Box>
      )}
    </Avatar>
  );
});

PersonaAvatar.displayName = 'PersonaAvatar';

export { PERSONA_SVGS, PERSONA_COLORS };
export default PersonaAvatar;
